import React from 'react';

const ErrorFallback = ({ error, onRetry }) => (
    <div className="h-[calc(100vh-250px)] flex flex-col items-center justify-center bg-gray-50 px-6">
        <div className="max-w-md w-full bg-white rounded-xl shadow-md overflow-hidden p-8 space-y-6 text-center">
            <div className="flex justify-center">
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="h-16 w-16 text-red-500"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                >
                    <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"
                    />
                </svg>
            </div>
            
            <h2 className="text-2xl font-bold text-gray-800">Something went wrong</h2>
            
            <div className="bg-red-50 border-l-4 border-red-500 p-4 text-left">
                <div className="flex">
                    <div className="flex-shrink-0">
                        <svg
                            className="h-5 w-5 text-red-500"
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 20 20"
                            fill="currentColor"
                        >
                            <path
                                fillRule="evenodd"
                                d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z"
                                clipRule="evenodd"
                            />
                        </svg>
                    </div>
                    <div className="ml-3">
                        <p className="text-sm text-red-700">{error.toString()}</p>
                    </div>
                </div>
            </div>
            
            <button
                onClick={onRetry}
                className="w-full flex justify-center items-center px-6 py-3 border border-transparent rounded-md shadow-sm text-base font-medium text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 transition-colors duration-200"
            >
                Try Again
            </button>
            
            <p className="text-sm text-gray-500">
                If the problem persists, please contact support.
            </p>
        </div>
    </div>
);

export default ErrorFallback;